/**
 * Public-facing "welcome" page copy — reached by scanning a QR code printed
 * on a physical device or box label (see `docs/device-fulfillment.md`).
 *
 * This is quick-setup copy for whoever just unboxed the player, not platform-
 * operator/admin copy (see `fulfilment.ts` for that). The page reads a query
 * parameter (e.g. the serial number) for display only — it does not do any
 * backend lookup.
 *
 * First draft for product review, not final marketing copy.
 */
export const welcome = {
  title: "Welcome to OmniMedia",
  thanks: "Thanks for picking up an OmniMedia player.",
  serialLabel: "Serial number",
  setup: {
    heading: "Quick setup",
    step1: "Plug in the player and power it on.",
    step2: "Sign in to your OmniMedia workspace, or create a new one.",
    step3: "Add this device from your dashboard so it's ready to play.",
  },
  cta: {
    home: "Go to OmniMedia",
    signIn: "Sign in to your workspace",
  },
} as const;
